var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContractIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Ico Custom Contract Tabs",
    viewBox: "0 0 14.35 19.48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".i-contract-search-icon{fill:currentColor}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.846 7.313)",
    "data-name": "Pfad 13648"
  }, /*#__PURE__*/React.createElement("path", {
    className: "contract-search-1",
    transform: "translate(-100.6 -907.43)",
    d: "M105.93 912.762a2.664 2.664 0 1 0-2.664-2.664 2.664 2.664 0 0 0 2.663 2.664zm0 1.333c-1.779 0-5.328.892-5.328 2.664v1.332h10.658v-1.332c0-1.772-3.551-2.659-5.33-2.659z",
    "data-name": "Pfad 13651"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 25703"
  }, /*#__PURE__*/React.createElement("path", {
    className: "contract-search-1",
    transform: "translate(-96.871 -900.89)",
    d: "m109.56 920.37h-11.034a1.66 1.66 0 0 1-1.658-1.659v-16.163a1.66 1.66 0 0 1 1.658-1.658h11.033a1.661 1.661 0 0 1 1.658 1.658v16.163a1.661 1.661 0 0 1-1.657 1.659zm-10.7-1.99h10.371v-15.5h-10.373z",
    "data-name": "Pfad 13652"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractIcon);
export default __webpack_public_path__ + "static/media/contractIcon.d5b131eeb352025b310cad33b0d77867.svg";
export { ForwardRef as ReactComponent };